<script>
	import LayoutBlog from './blog/_layouts/LayoutBlog.svelte';
	import LayoutMinimal from './blog/_layouts/LayoutMinimal.svelte';

	export let metadata;
	export let context;
	export let pathname;

	const layouts = {
		blog: LayoutBlog
	};

	// @ts-ignore
	const layout = layouts[metadata.type] || LayoutMinimal;
</script>

<svelte:component this={layout} {metadata} {context} {pathname}>
	<slot />
</svelte:component>
